import { derived } from 'svelte/store';
import { token } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/token.js?1733898722653';
import { customer } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/customer.js?1733898722653';

function is_logged_in() {
    return derived([token, customer], ([$token, $customer], set) => {
        const value = $token && $customer?.token && $token === $customer?.token;
        set(!!value);
    });
}

export default is_logged_in();
